(ns app.components.icons.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]
   [garden.stylesheet :refer [at-media]]))



(defclass active-icon
  []
  {:border-radius "50%"
   :width "80px"
   :height "80px"}
  [(at-media {:max-width "766px"}
             {:width "40px"
              :height "40px"})])

(defclass static-icon
  []
  {:border-radius "50%"
   :width "24px"
   :height "24px"})